import { Component } from '@angular/core';
import { BeneficiaryService } from '../Services/beneficiary.service';
import { NgModule } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { BeneficiaryAccountProperties, ERPBackOffliceBankList } from '../Models/BeneficiaryAccountProperties';
import { BeneficiaryAccountAllocationProperties } from '../Models/BeneficiaryAccountProperties';
import { Location } from '@angular/common';
import { UrlRequest } from '../Models/AgencyMasterProperties';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import { AgencyService } from '../Services/Agency.service';



@Component({
  selector: 'create-beneficiary-account',
  templateUrl: './create-beneficiary-account.component.html',
  styleUrls: ['./create-beneficiary-account.component.css']
})
@NgModule({ imports: [FormsModule] })

export class CreateBeneficiaryAccountComponent {
  beneficiaryData: BeneficiaryAccountProperties[] = [];
  beneficiaryAllocation: BeneficiaryAccountAllocationProperties[] = [];
  primeShowModalBeneficiaryModel: boolean = false;
  beneficiaryFormHeading: string;
  beneficiaryButtonText: string;
  beneficiaryObject = new BeneficiaryAccountProperties();
  formData!: FormGroup;
  disabledField: boolean = false;
  startDisabled: boolean = true;
  loaderConfimVar: boolean = false;
  disabeldButtons: boolean = false;
  beneficiaryAccountSubmitted: boolean = false;
  private requestURL = new UrlRequest();
  backSystemCompanies: CompanyMasterProperties[] | undefined;
  erpBackOffliceBankList: ERPBackOffliceBankList[] | undefined;
  accountNumberAlreadyExist: boolean;
  ibanAlreadyExist: boolean;
  erpLoader: boolean = false;


  constructor(private beneficiaryService: BeneficiaryService, private location: Location, private fb: FormBuilder
    , private agencyService: AgencyService) { };
  ngOnInit(): void {
    this.GetCompanyMaster()
    this.CreateBeneficiaryForm();
    this.GetBeneficiaryData();
    this.CheckBeneficaryAccountRight();

  }
  private GetCompanyMaster = (): void => {
    this.agencyService.GetCompanyMaster().subscribe(data => {
      this.backSystemCompanies = data;
    })
  }
  private CheckBeneficaryAccountRight = (): void => {
    this.beneficiaryService.CheckRightsAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
      if (data == false) {
        this.location.back();
      }
    });
  }
  private GetBeneficiaryData = (): void => {
    try {
      this.beneficiaryService.getBeneficiary(localStorage.getItem("AgencyId")).subscribe((data) => {
        this.beneficiaryData = data;
      });
    }
    catch (e) {
      console.log(e);
    }
  }
  public ChangeBeneficiaryStatus = (accountNo: string, isActive: boolean, beneficiaryId: number): void => {
    try {

      this.beneficiaryService.statusChangeBeneficiaryAccount(accountNo, isActive, beneficiaryId).subscribe(() => { });
    }
    catch (e) {
      console.log(e);
    }
  }
  public AddNewBeneficiaryAccount = (): void => {

    this.beneficiaryFormHeading = "Add New Beneficiary";
    this.beneficiaryButtonText = "Save";
    this.primeShowModalBeneficiaryModel = true;
  }
  private CreateBeneficiaryForm = (): any => {
    this.formData = this.fb.group({
      beneficiaryId: 0,
      creationUser: Number(localStorage.getItem("UserId")),
      backSystemCompanyId: [0, Validators.required],
      name: ['', Validators.required],
      reference: ['', Validators.required],
      agencyId: localStorage.getItem("AgencyId"),
      accountNo: ['', Validators.required],
      accountTitle: ['', Validators.required],
      branch: ['', Validators.required],
      bankName: ['', Validators.required],
      iban: ['', Validators.required],
      swift: ['', Validators.required],
      glAccountNumber: '',
      glAccountName: '',
      branchLocation: '',
      bankId: 0,
      creationTime: new Date,
      modifyUser: 0,
      modifyTime: new Date,
      isActive: false,
    },
      {
        validators: [this.CheckBeneficiaryAccountNumberValidation('accountNo'), this.CheckBeneficiaryIBanValidation('iban')]
      }
    );

  }
  public GetControls = (): any => {
    return this.formData.controls;
  }
  private CheckBeneficiaryAccountNumberValidation = (accountNo: any): any => {
    return (formGroup: FormGroup) => {
      const accountNumber = formGroup.controls[accountNo];
      if (accountNumber.errors && !accountNumber.errors["CheckBeneficiaryAccountNumberValidation"]) {
        return false;
      }
      this.beneficiaryService.CheckBeneficiaryAccountNumberValidation(this.beneficiaryObject.beneficiaryId, accountNumber.value).subscribe((isExist) => {
        this.accountNumberAlreadyExist = isExist;
        if (this.accountNumberAlreadyExist == true) {
          accountNumber.setErrors({ CheckBeneficiaryAccountNumberValidation: true });
        }
        else {
          accountNumber.setErrors(null);
        }
      });
    }

  }
  private CheckBeneficiaryIBanValidation = (iban: any): any => {
    return (formGroup: FormGroup) => {
      const ibanNumber = formGroup.controls[iban];
      if (ibanNumber.errors && !ibanNumber.errors["CheckBeneficiaryIBanValidation"]) {
        return false;
      }
      this.beneficiaryService.CheckBeneficiaryIBanValidation(this.beneficiaryObject.beneficiaryId, ibanNumber.value).subscribe((isExist) => {
        this.ibanAlreadyExist = isExist;
        if (this.ibanAlreadyExist == true) {
          ibanNumber.setErrors({ CheckBeneficiaryIBanValidation: true });
        }
        else {
          ibanNumber.setErrors(null);
        }
      });
    }

  }


  public GetERPBackOfficeBankList = (backSystemCompanyId: number): void => {
    try {
      if (backSystemCompanyId != 0 && backSystemCompanyId != null && backSystemCompanyId != undefined) {
        const filterComapny = this.backSystemCompanies.find(id => id.companyId === backSystemCompanyId);
        if (filterComapny) {
          this.erpLoader = true;
          this.requestURL.request = filterComapny.companyURL;
          this.beneficiaryService.GetERPBackOfficeBankList(this.requestURL).subscribe(data => {
            this.erpBackOffliceBankList = data;
            this.erpLoader = false;
            if (this.erpBackOffliceBankList != null && this.erpBackOffliceBankList != undefined) {
              this.startDisabled = false;
            }
          });
        }
      }
      else {
        this.erpBackOffliceBankList = null;
        this.startDisabled = true;
      }
    }
    catch (ex) {
      console.log(ex)
    }
  }
  public AssigneGLAccountNumber = (bank: string): void => {
    if (bank != "" && bank != null && bank != undefined) {
      const glAccount = this.erpBackOffliceBankList.find(x => x.bankName === bank);
      if (glAccount) {
        this.formData.get('glAccountNumber').setValue(glAccount.glAccountNumber);
        this.formData.get('glAccountName').setValue(glAccount.glAccountName);
        this.formData.get('bankId').setValue(glAccount.bankId);
        this.formData.get('branchLocation').setValue(glAccount.branchLocation);
        this.beneficiaryObject.glAccountNumber = glAccount.glAccountNumber;
        this.beneficiaryObject.glAccountName = glAccount.glAccountName;
        this.beneficiaryObject.bankId = glAccount.bankId;
        this.beneficiaryObject.branchLocation = glAccount.branchLocation;
      }
    }
    else {
      this.beneficiaryObject.glAccountNumber = null;
      this.beneficiaryObject.glAccountName = null;
      this.beneficiaryObject.bankId = 0;
      this.beneficiaryObject.branchLocation = null;
      this.formData.get('glAccountNumber').setValue('');
      this.formData.get('glAccountName').setValue('');
      this.formData.get('branchLocation').setValue('');
      this.formData.get('bankId').setValue(0);
    }
  }

  public SubmitBeneficiaryAccount = (): boolean => {
    let beneficiaryValidation: boolean;
    let validation: boolean = true;
    this.beneficiaryAccountSubmitted = true;
    const resMessage = document.getElementById("errorBeneficiaryAccount");
    if (this.formData.invalid) {
      resMessage.innerHTML = "**Invalid Required Fields";
      resMessage.style.color = 'red';
      setTimeout(() => {
        resMessage.innerHTML = "";
        resMessage.style.color = "";
      }, 4000);
      beneficiaryValidation = false;
    }
    else {
      if (this.beneficiaryObject.iban.includes(this.beneficiaryObject.accountNo) == false) {
        validation = false;
        beneficiaryValidation = false;
        const ibanIDField = document.getElementById("IbanNumberField");
        const ibanID = document.getElementById("baneficiaryIbanError2");
        const ibanNumberLabel = document.getElementById("IbanNumberLabel");
        ibanID.innerHTML = "**Invalid IBAN Number!";
        ibanIDField.classList.add("invalid-Error");
        ibanNumberLabel.classList.add("labelofmodifyserachinputsError");
        resMessage.innerHTML = "**Invalid IBAN Number!";
        resMessage.style.color = 'red';
        setTimeout(() => {
          ibanID.innerHTML = "";
          resMessage.innerHTML = "";
          resMessage.style.color = "";
          ibanIDField.classList.remove("invalid-Error")
          ibanNumberLabel.classList.remove("labelofmodifyserachinputsError")
        }, 4000);
        return beneficiaryValidation;
      }
      if (validation == true) {
        this.loaderConfimVar = true;
        this.disabeldButtons = true;
        if (this.beneficiaryObject.beneficiaryId == 0) {
          this.formData.get('beneficiaryId').setValue(0);
          this.beneficiaryObject = this.formData.value;
          this.beneficiaryObject.creationUser = Number(localStorage.getItem("UserId"));
          this.beneficiaryObject.creationTime = new Date;
          this.beneficiaryObject.modifyTime = new Date;
          this.beneficiaryObject.modifyUser = 0;
          this.beneficiaryService.createBeneficiary(this.beneficiaryObject).subscribe(res => {

            if (res == true) {
              this.CloseBeneficiaryModel();
              this.disabeldButtons = false;
              this.GetBeneficiaryData();
              // resMessage.innerHTML = "Beneficiary Account Created Successfully!";
              // resMessage.style.color = '#25db34';
              // this.loaderConfimVar = false;
              // setTimeout(() => {
              //   resMessage.innerHTML = "";
              //   resMessage.style.color = '';
              //   this.CloseBeneficiaryModel();
              //   this.disabeldButtons = false;
              // }, 4000);
            } else {
              resMessage.innerHTML = "**Something Went Wrong!";
              resMessage.style.color = 'red';
              this.loaderConfimVar = false;
              this.disabeldButtons = false;
              setTimeout(() => {
                resMessage.innerHTML = "";
                resMessage.style.color = '';
              }, 4000);
            }
          })
        }
        else {
          this.beneficiaryObject.modifyUser = Number(localStorage.getItem("modifyUser"));
          this.beneficiaryService.updateBeneficiary(this.beneficiaryObject).subscribe((res => {
            if (res == true) {
              this.GetBeneficiaryData();
              resMessage.innerHTML = "Beneficiary Account Updated Successfully!";
              resMessage.style.color = '#25db34';
              this.loaderConfimVar = false;
              setTimeout(() => {
                resMessage.innerHTML = "";
                resMessage.style.color = '';
                this.CloseBeneficiaryModel();
                this.disabeldButtons = false;
              }, 4000);
            } else {
              resMessage.innerHTML = "**Something Went Wrong!";
              resMessage.style.color = 'red';
              this.loaderConfimVar = false;
              this.disabeldButtons = false;
              setTimeout(() => {
                resMessage.innerHTML = "";
                resMessage.style.color = '';
              }, 4000);
            }
          }));
        }
      }
    }
    return beneficiaryValidation;
  }
  public EditBeneficiaryAccount = (beneficiaryId: number, accountNo: string): void => {
    if (beneficiaryId > 0 && accountNo != "") {
      this.beneficiaryService.GetBeneficiaryByIdAndAccount(beneficiaryId, accountNo).subscribe((data) => {
        this.beneficiaryObject = data;
        if (this.beneficiaryObject.backSystemCompanyId > 0) {
          this.GetERPBackOfficeBankList(this.beneficiaryObject.backSystemCompanyId);
        }
        this.beneficiaryFormHeading = "Update Beneficiary";
        this.beneficiaryButtonText = "Update";
        this.primeShowModalBeneficiaryModel = true;
      });
    }
  }
  public CloseBeneficiaryModel = (): void => {
    this.primeShowModalBeneficiaryModel = false;
    this.beneficiaryObject = new BeneficiaryAccountProperties();
    this.formData.reset();
    this.beneficiaryAccountSubmitted = false;
    this.loaderConfimVar = false;
    this.disabeldButtons = false;
  }









  // public vari: string;

  // constructor(private usersService: UsersService, private http: HttpClient, private router: Router, private beneficiaryService: BeneficiaryService, private agencyService: AgencyService) { };
  // beneficiaryCObj = new BeneficiaryAccountProperties();

  // beneficiaryAllocationObj = new BeneficiaryAccountAllocationProperties();
  // beneficiaryData: BeneficiaryAccountProperties[] = [];
  // agencyRightsData = new AgencyRightsProperties();

  // //beneficiaryAllocationByAgencyId: BeneficiaryAccountAllocationProperties[] = [];
  // allAlloctedData: AllocatedBeneficiaryAccounts[] = [];
  // beneficiaryAllocation: BeneficiaryAccountAllocationProperties[] = [];
  // beneficiaryAccounts: BeneficiaryAccountProperties[] = [];
  // //accAllocationObj = new BeneficiaryAccountAllocationProperties();
  // @ViewChild('userGrid', { static: false }) dataGrid: DxDataGridComponent;
  // collapsed = false;

  // isExpanded = false;

  // collapse() {
  //   this.isExpanded = false;
  // }

  // toggle() {
  //   this.isExpanded = !this.isExpanded;
  // }



  // contentReady = (e) => {
  //   $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
  //   if (!this.collapsed) {
  //     this.collapsed = true;
  //     e.component.expandRow(["EnviroCare"]);
  //   }
  // };

  // ngOnInit() {


  //   NaveStartup();
  //   let agencyId = (localStorage.getItem("agencyId"));
  //   if (agencyId != "" && agencyId != null) {
  //     $(".beneficiary_accounts").css({ "display": "none" });
  //     $(".add-beneficiary").css({ "display": "none" });
  //     $("#disabled-btn").addClass("disabled-btn");
  //     this.getByAgencyId(agencyId);
  //     localStorage.removeItem("agencyId");
  //   }
  //   else {
  //     $(".users_beneficiary").css({ "display": "none" });
  //     this.getBeneficiaryData();
  //   }
  //   this.getAgencyRightsData();
  //   this.checkBeneficaryAccountRight();

  // }

  // checkBeneficaryAccountRight() {
  //   this.beneficiaryService.CheckRightsAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
  //     if (data) {

  //       $("#btnSave").removeAttr("disabled");
  //     }
  //     else {
  //       $("#btnSave").attr("disabled", "disabled");
  //     }
  //   });
  // }


  // onSubmit() {

  //   this.beneficiaryCObj.creationUser = Number(localStorage.getItem("creationUser"));
  //   this.beneficiaryCObj.agencyId = localStorage.getItem("AgencyId");
  //   if (this.beneficiaryCObj.accountNo != "" && this.beneficiaryCObj.name != "" && this.beneficiaryCObj.reference != "" && this.beneficiaryCObj.agencyId != "" && this.beneficiaryCObj.accountTitle != "" && this.beneficiaryCObj.bankName != "" && this.beneficiaryCObj.branch != "" && this.beneficiaryCObj.iban != "") {
  //     this.beneficiaryService.createBeneficiary(this.beneficiaryCObj).subscribe((data => {
  //       if (data === true) {
  //         this.getBeneficiaryData();
  //         this.beneficiaryCObj = new BeneficiaryAccountProperties();
  //         $("#response-screen").show();
  //         document.getElementById("response-screen").innerHTML = "Account created Successfully :)"
  //         $("#response-screen").delay(5000).hide(1000);
  //       }
  //       else {
  //         $("#response-screen").show();
  //         document.getElementById("response-screen").innerHTML = "Error occured while creating Account :("
  //         $("#response-screen").delay(5000).hide(1000);
  //       }
  //     }));
  //   }
  //   else {
  //     $("#response-screen").show();
  //     document.getElementById("response-screen").innerHTML = "Please fill in All Required fields"
  //     $("#response-screen").delay(5000).hide(1000);
  //   }
  // }
  // cancel() {
  //   this.beneficiaryCObj = new BeneficiaryAccountProperties();
  // }

  // getBeneficiaryData() {
  //   try {
  //    // this.beneficiaryCObj.agencyId = localStorage.getItem("AgencyId");
  //     this.vari = localStorage.getItem("AgencyId")
  //     this.beneficiaryService.getBeneficiary(this.vari).subscribe((data) => {
  //       this.beneficiaryData = data;
  //     });
  //   }
  //   catch (e) {  }
  // }

  // getAgencyRightsData() {
  //   try {

  //     this.vari = localStorage.getItem("AgencyId")
  //     this.agencyService.GetAgencyRightsById(this.vari).subscribe((data) => {
  //       this.agencyRightsData = data;
  //     });
  //   }
  //   catch (e) {  }
  // }



  // getBeneficiaryAccountNo(accountNo: string) {
  //   try {
  //     localStorage.setItem('accountNo', accountNo)
  //     this.router.navigateByUrl('/update-beneficiary-account');
  //   }
  //   catch (e) {
  //     //console.log(e);
  //   }
  // }
  // //getBeneficiaryDeleted(accountNo: string) {
  // //  try {
  // //    this.beneficiaryService.deleteBeneficiary(accountNo).subscribe((data) => {
  // //      //console.log(data);
  // //    });
  // //  }
  // //  catch (e) {
  // //    //console.log(e);
  // //  }
  // //}

  // changeStatus(accountNo: string, isActive: boolean) {
  //   try {
  //     this.beneficiaryService.statusChangeBeneficiaryAccount(accountNo, isActive).subscribe((data) => {
  //       //console.log(data);
  //     });
  //   }
  //   catch (e) {
  //     //console.log(e);
  //   }
  // }
  // getByAgencyId(agencyId) {
  //   try {
  //     this.beneficiaryService.getBeneficiaryAccAllocationByAgencyId(agencyId).subscribe((data) => {
  //       this.allAlloctedData = data;
  //     });
  //   }
  //   catch (e) {
  //     //console.log(e);
  //   }
  // }




}
